import React, { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { useTranslation } from "react-i18next";

const ComposeMessage = () => {
  const handelAudio = (e) => {};
  const { sidebar, setSidebar, Dark, setDark } = useContext(AppContext);
  const { t, i18n } = useTranslation();

  return (
    <main className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div id="cx-wrapper" className="ComposeMessage">
        <div className="main-master-wrapper">
          <div className="Heading">
            <p>{t("Compose Message")}</p>
          </div>
          <div className="innerInputsGen mainVehAccident ">
            <div className="insideInpts">
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12 form_input_main">
                  <div className="innerSelectBox weekCounter">
                    <Form.Label className="common-labels">{t("To")}</Form.Label>
                    <Form.Select as="select" type="select" name="Speed_limit">
                      <option value="">Select Person...</option>
                      <option value="0">Person1</option>
                      <option value="1">Person2</option>
                      <option value="2">Person3</option>
                    </Form.Select>
                  </div>
                </div>
                <div className="select_vehicle_icon col-lg-6 col-md-12 col-sm-12 form_input_main">
                  <Form.Label className="common-labels" For="file">
                    Subject
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Your New Subject..."
                  />
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 form_input_main">
                  <Form.Label className="common-labels" For="file">
                    {t("Content")}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    placeholder="Type Your Message..."
                  />
                </div>
              </div>
            </div>
            {/* Two Bottom Buttons */}
            <div className="d-flex justify-content-end align-items-center btn-wrapper">
              <Link to="#" className="innerLink">
                <button className="cx-btn-1 mx-2">{t("Cancel")}</button>
              </Link>
              <Link to="#" className="innerLink">
                <button className="cx-btn-2">{t("Submit")}</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ComposeMessage;
